import React from 'react';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { Route, State as RouteState } from 'config/routes';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { routeSelector } from 'store/state/selectors/router';
import { FavoriteNeighbourhoodWidget } from './FavoriteNeighbourhoodWidget';

interface Props {
  route: RouteState;
}

const BaseHeaderSaveNeighbourhoodWidget: React.FC<Props> = props => {
  const isMobile = useScreenBreakpoint() < 3;
  const { route } = props;

  if (!isMobile || route.name !== Route.InvestorsNeighbourhoodPage || !route.params.id || (route.name === Route.InvestorsNeighbourhoodPage && route.params.compareId)) return null;

  return <FavoriteNeighbourhoodWidget docId={route.params.id} />;
};

const mapStateToProps = (state: State) => ({
  route: routeSelector(state),
});

export const HeaderSaveNeighbourhoodWidget = connect(mapStateToProps)(BaseHeaderSaveNeighbourhoodWidget);
